import { render, staticRenderFns } from "./EPMProfileForm.vue?vue&type=template&id=23034b0a"
import script from "./EPMProfileForm.vue?vue&type=script&lang=js"
export * from "./EPMProfileForm.vue?vue&type=script&lang=js"
import style0 from "./EPMProfileForm.vue?vue&type=style&index=0&id=23034b0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports